import { Link } from "react-router-dom";
import { motion, useMotionValue, useSpring, useTransform } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { SERVICE_ICONS } from "../../data/content";

export default function TiltServiceCard({ service, index }) {
  const x = useMotionValue(0);
  const y = useMotionValue(0);
  const rx = useSpring(useTransform(y, [-0.5, 0.5], [10, -10]), { stiffness: 200, damping: 18 });
  const ry = useSpring(useTransform(x, [-0.5, 0.5], [-10, 10]), { stiffness: 200, damping: 18 });
  const Icon = SERVICE_ICONS[service.icon] || ArrowUpRight;

  const onMove = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    x.set((e.clientX - r.left) / r.width - 0.5);
    y.set((e.clientY - r.top) / r.height - 0.5);
  };
  const reset = () => { x.set(0); y.set(0); };

  return (
    <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
      transition={{ delay: index * 0.08, duration: 0.6 }} style={{ perspective: 1000 }}>
      <motion.div onMouseMove={onMove} onMouseLeave={reset} style={{ rotateX: rx, rotateY: ry, transformStyle: "preserve-3d" }}
        className="group relative h-full overflow-hidden rounded-3xl border border-slate-200 bg-white p-8 shadow-sm transition-shadow duration-300 hover:shadow-[0_30px_60px_-20px_rgba(7,20,38,0.25)]">
        <div className="absolute -right-16 -top-16 h-40 w-40 rounded-full bg-mint/0 blur-2xl transition-colors duration-500 group-hover:bg-mint/20" />
        <Link to={`/${service.slug}`} data-testid={`service-card-${service.slug}`} className="relative block" style={{ transform: "translateZ(40px)" }}>
          <div className="flex items-start justify-between">
            <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-navy text-gold shadow-lg transition-transform duration-300 group-hover:scale-110"><Icon size={24} /></div>
            <span className="font-num text-xs text-slate-400">0{index + 1}</span>
          </div>
          <h3 className="mt-8 text-xl font-bold text-navy">{service.title}</h3>
          <p className="mt-3 text-sm leading-relaxed text-slate-600">{service.summary}</p>
          <ul className="mt-6 flex flex-wrap gap-2">
            {service.items.slice(0, 4).map((it) => (
              <li key={it.title} className="rounded-full bg-slate-100 px-3 py-1 text-xs text-slate-600">{it.title}</li>
            ))}
          </ul>
          <span className="mt-8 inline-flex items-center gap-1.5 text-sm font-semibold text-mint-600">
            Explore <ArrowUpRight size={16} className="transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
          </span>
        </Link>
      </motion.div>
    </motion.div>
  );
}
